export default "__VITE_ASSET__0lbPI3T4__"